// Los cuatro estados de toda pantalla · DIRECTRIZ-EXPERIENCIA E2
//
// Reproduce el patrón H5 de la consola (`consola/estatico/consola.css`,
// «Cargando: filas fantasma con la forma de las de verdad»; «Vacío y
// error: con su acción dentro») para el cliente React, sin reinventarlo:
//
//   · CARGANDO  → filas fantasma (no un «Cargando…» suelto); quien pidió
//                 menos movimiento en su sistema no ve la animación.
//   · VACÍO     → `EstadoVacio` de siempre: qué es, por qué está vacío y
//                 el botón de la acción DENTRO.
//   · SIN COINCIDENCIAS → es otro vacío y se dice distinto: «ninguna
//                 coincide con lo que buscaste» manda a cambiar el filtro,
//                 no a crear.
//   · ERROR     → las tres cosas (qué pasó, por qué, qué hacer) y el botón
//                 «Volver a intentarlo». Un error que solo describe deja a
//                 quien lo lee recargando la página a ver si suena la flauta.
//   · LLENO     → lo pinta cada pantalla.
import { RefreshCw, SearchX } from 'lucide-react';
import EstadoVacio from './EstadoVacio';
import { motivoDeError } from './estados';

export { EstadoVacio };

export function Cargando({ filas = 4, alto = 'h-12', etiqueta = 'Cargando' }) {
  return (
    <div role="status" aria-busy="true" aria-label={etiqueta} className="esqueleto divide-y divide-gray-100 rounded-xl border border-gray-200 bg-white overflow-hidden">
      {Array.from({ length: filas }).map((_, i) => (
        <div key={i} className={`esqueleto-fila ${alto}`} />
      ))}
      <span className="sr-only">{etiqueta}…</span>
    </div>
  );
}

export function SinCoincidencias({ que = 'Ninguna coincide con lo que buscaste', pista = 'Cambia el filtro o la búsqueda de arriba.', onLimpiar }) {
  return (
    <EstadoVacio
      icono={SearchX}
      titulo={que}
      descripcion={pista}
      accion={onLimpiar && (
        <button type="button" onClick={onLimpiar} className="mt-1 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700">
          Quitar filtros
        </button>
      )}
    />
  );
}

// EL MOTIVO PASA POR `motivoDeError` · TODO-SIRVE F3, 30 sep 2026. Las
// pantallas le pasan `porque={e.message}`, y cuando la petición no llegó al
// servidor ese mensaje es el crudo del navegador, en inglés («Failed to
// fetch»). El censo de la 3.15.176 lo midió en Personal: el expediente y
// las tarjetas de una persona decían «Failed to fetch» y nada más. La regla
// T-05 ya lo prohibía en las listas (`ListaEstandar`); aquí faltaba.
export function ErrorConReintento({ que = 'No se pudo cargar esta pantalla', porque, onReintentar, ocupado = false }) {
  const motivo = motivoDeError(porque);
  return (
    <div role="alert" className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-900">
      <strong className="block">{que}</strong>
      <p className="mt-1 text-red-800">
        {motivo || 'Puede ser un corte de red de un momento, o que el servidor se haya reiniciado. No se ha perdido nada: la información no llegó, eso es todo.'}
      </p>
      {onReintentar && (
        <button type="button" onClick={onReintentar} disabled={ocupado}
          className="mt-3 inline-flex items-center gap-1.5 rounded-lg border border-red-300 bg-white px-3 py-2 text-sm font-semibold text-red-800 disabled:opacity-60">
          <RefreshCw className="h-4 w-4" aria-hidden="true" /> Volver a intentarlo
        </button>
      )}
    </div>
  );
}
